export default "__VITE_ASSET__muqEJAUX__"